<template>
    <router-view class="bcd"></router-view>
</template>
<script setup lang="ts">
import { controlDeferred } from '@eureka/utils/control';
import { UsageAmountWhere } from '@eureka/shared/edition-upgrade/src/constants';
import { EurekaPackageType } from '@eureka/services/src/apis/common.api.types';
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';

const PAYMENT_SUCCESS_STATE = 'success';
const AUTHORIZATION_STORAGE_KEY = 'patsnap-authorizations';
const PAYMENT_SUCCESS_RELOAD_DELAY = 3000;

const route = useRoute();
const paymentSuccessHandled = ref(false);

function removeHistoryQueries(queryKeys: string[]) {
    const hash = window.location.hash;
    const hashParts = hash.split('?');
    const hashPath = hashParts[0];
    const queryString = hashParts[1] || '';
    const searchParams = new URLSearchParams(queryString);

    queryKeys.forEach((key) => {
        searchParams.delete(key);
    });

    const newSearch = searchParams.toString();
    const newHash = `${hashPath}${newSearch ? `?${newSearch}` : ''}`;
    const newUrl = `${window.location.pathname}${newHash}`;

    window.history.replaceState('', document.title, newUrl);
}

async function openEditionUpgradeFirstLogin() {
    const { is_first_login_after_try_end } = await controlDeferred.promise;
    if (is_first_login_after_try_end) {
        import('@eureka/shared/edition-upgrade').then((mod) => {
            mod.prepareFirstLoginAfterTrial(UsageAmountWhere.TECH_SEEK, EurekaPackageType.AIR_COMMERCIAL);
        });
    }
}

watch(
    () => route.query.payment_state,
    (paymentState) => {
        if (paymentSuccessHandled.value || paymentState !== PAYMENT_SUCCESS_STATE) return;

        paymentSuccessHandled.value = true;
        console.debug('[TelecomPayment] payment success callback detected, refresh authorization state.');
        removeHistoryQueries(['payment_state']);
        localStorage.removeItem(AUTHORIZATION_STORAGE_KEY);
        window.setTimeout(() => {
            window.location.reload();
        }, PAYMENT_SUCCESS_RELOAD_DELAY);
    },
    { immediate: true }
);

openEditionUpgradeFirstLogin();

</script>
